import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

var QuestionResults = Backbone.Model.extend({

    idAttribute: 'id',

    getHighestPercentage: function() {
        if (this.get('resultsPercentage')){
            return _.max(_.values(this.get('resultsPercentage')));
        }

        return 0;
    }

});

export default QuestionResults;

